import { createFileRoute } from "@tanstack/react-router";
import {
  CustomIndustryServicePage,
  buildCustomIndustryServiceHead,
} from "@/components/CustomIndustryServicePage";
import { getCustomEntry } from "@/lib/customIndustryServiceData";

const ENTRY = getCustomEntry("web-design-for-plumbing")!;

export const Route = createFileRoute("/web-design-for-plumbing")({
  head: () => buildCustomIndustryServiceHead(ENTRY),
  component: () => <CustomIndustryServicePage entry={ENTRY} />,
});
